import { useCallback, useMemo } from 'react';
import { contactCreateAPISchema } from '@hero/api';
import { UseContactCreateApiBody } from '@hero/api-hooks';
import { Contact, getObjectId } from '@hero/schema';
import { useFormUtil, UseFormOptions } from '../utils';

type UseContactCreateFormOptions = UseFormOptions<UseContactCreateApiBody>;

export const useContactCreateForm = (options?: UseContactCreateFormOptions) => {
  const getDefaultValues = (
    values?: Partial<UseContactCreateApiBody>,
  ): UseContactCreateApiBody => ({
    name: '',
    phone: '',
    email: '',
    customerId: undefined,
    ...values,
  });

  const getResetValues = () => getDefaultValues();

  function convertToFormValues(contact: Contact): UseContactCreateApiBody {
    return {
      name: contact.name ?? '',
      phone: contact.phone ?? '',
      email: contact.email ?? '',
      customerId: contact.clients?.[0]?._id ? getObjectId(contact.clients[0]._id) : undefined,
    };
  }

  const defaultValues = useMemo(
    () => getDefaultValues(options?.defaultValues),
    [options?.defaultValues],
  );

  const form = useFormUtil({
    zodSchema: contactCreateAPISchema,
    ...options,
    defaultValues,
    getResetValues,
  });

  const setContact = useCallback(
    (contact: Contact) => {
      form.reset(convertToFormValues(contact));
    },
    [form.reset],
  );

  return {
    ...form,
    setContact,
  };
};
